import { Box, useTheme } from 'native-base'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { useHistoryTabView } from './hooks/useHistoryScreenTabView'

import { LoadingState, ScreenHeaderWithPoints, Spacer } from '~components'
import { useTranslation } from '~hooks'

export const HistoryScreen = (_: HistoryScreenProps): JSX.Element => {
  const { t } = useTranslation()
  const { space } = useTheme()
  const { top } = useSafeAreaInsets()
  const { isLoadingHistory, offersListWithTabBarView } = useHistoryTabView()

  return (
    <Box flex={1} flexGrow={1} pt={`${top + space['8']}px`} bgColor="background">
      <ScreenHeaderWithPoints title={t('common.history')} />
      <Spacer y="4" />
      {isLoadingHistory ? <LoadingState /> : offersListWithTabBarView}
    </Box>
  )
}
